import React, {useEffect, useState, useCallback} from 'react'; 
import {useSelector, useDispatch} from 'react-redux';
import allActions from '../../actions';
import { Pagination, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import ItemAirdrop from './itemAirdrop'; 
import ImgNodata from '../common/asset/images/nodata2.svg'; 
import { Loader } from '../common/component';
import { useOutletContext, useLocation} from 'react-router-dom';
import IconSearch from '../common/asset/images/icon-search.svg'; 

const antIcon = <LoadingOutlined style={{ fontSize: 100 }} spin />;

const OpeningAirdrop = () => {
    const [searchText, setSearchText] = useState(); 
    const dispatch = useDispatch();
    const [page, setPage] = useState(0);
    const [loadingPage, setLoadingPage] = useState(false);
    let size = 6;
    const status = 'OPENING';
    const sort = 'priority,desc';
    const keySearch = '';   
    
    useEffect(() => {
        setLoadingPage(true);
        if(searchText) {
            dispatch(allActions.airdropAction.getAirdropByStatus({status, keySearch: searchText, sort, page, size}, (res)=>{
                if(res.callResult === true) {
                    setLoadingPage(false);
                }
            }));
        }
        else{
            dispatch(allActions.airdropAction.getAirdropByStatus({status, keySearch, sort, page, size}, (res)=>{
                if(res.callResult === true) {
                    setLoadingPage(false);
                }
            }));
        }  
    }, [dispatch, page]);

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    }
    const handleSubmit = () => {
        setLoadingPage(true);
        dispatch(allActions.airdropAction.getAirdropByStatus({status, keySearch: searchText, sort, page, size}, (res)=>{
            if(res.callResult === true) {
                setLoadingPage(false);
            }
        })); 
    } 


    function onChangePaging(pageNumber) {
        setPage(pageNumber - 1);
    } 

    const airdropListData = useSelector(state => state.airdrop); 
    const { airdropList, airdropsCount } = airdropListData; 
   
    const elmItem = airdropList && airdropList.length > 0 && airdropList.map((item,key) => (
        <ItemAirdrop key={key} item={item}/>
    ));

    return(
        <>  
        <div className="p-airdrop__search">
            <input onKeyDown={(e) => {
                if(e.code === "Enter"){ 
                    console.log("asdasdas");
                    handleSubmit(e); 
                    }}}
                onChange={(e) => handleSearch(e)}
                type="text" placeholder="Search bounty / airdrop" />
            <button onClick={()=> handleSubmit()} type="submit"><img src={IconSearch} alt="Search" /></button>
        </div>
             
         {loadingPage ?<Loader /> : (
            <>
            <div className="p-airdrop">  
                <div className="c-list">
                    {elmItem && elmItem.length > 0 ? elmItem : <div className="c-nodata c-nodata--airdrop">
                        <img src={ImgNodata} alt="NoData" />
                        <p>Free Airdrops & Bounties<br/>Coming Soon</p>
                    </div>}
                </div>
            </div>
            {!loadingPage && <div className="pani-list">
                {airdropList && airdropList.length > 0 && 
                <Pagination
                    current={page + 1}
                    defaultCurrent={1}
                    total={airdropsCount}
                    pageSize={size}
                    onChange={onChangePaging}
                    showSizeChanger={false}
                />}
            </div>}
            </>
            )}
        </>
    );
};

export default OpeningAirdrop;